const INPUT_SELECTOR = 'select[multiple].select2-fw.in-tags';

const OPTION_DEFAULTS = {
    closeOnSelect: false,
    placeholder: '',
    width: '100%',
    tags: true,
    tokenSeparators: [','],
    allowClear: true,
    language: {
        noResults: function() {
            return 'Type to add values. Separate with a comma.';
        },
    },
    templateSelection: function(tag, container) {
        /**
         * For each `option` in the select, if it has the locked attribute, add a `.locked` class to the tag.
         * This allows us to ignore unsetting these values.
         */
        if (tag.element?.hasAttribute('locked')) {
            $(container).addClass('locked');
            tag.locked = true;
        }

        return tag.text;
    },
};

const TagsInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);

        $inputs.each(function() {
            const $input = $(this);
            const options = Object.assign({}, OPTION_DEFAULTS);

            $input
                .select2(options)
                .on('select2:unselecting', function(e) {
                    if (e?.params?.args?.data?.element?.hasAttribute('locked') ?? false) {
                        e.preventDefault();
                    }
                })
                .on('select2:select', function() {
                    let $searchField = $('.select2-search__field');
                    if ($searchField) {
                        $searchField.val('');
                    }
                });

            if ($input.data('value')) {
                const initialValues = $input.data('value').split(',');

                for (let i = 0; i < initialValues.length; i++) {
                    $input
                        .append(
                            new Option(
                                initialValues[i],
                                initialValues[i],
                                true,
                                true,
                            ),
                        );
                }

                $input.trigger('change');
            }
        });
    },
    destroy: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);

        $inputs.each(function() {
            const $input = $(this);
            $input.select2('destroy');
        });
    },
};

export default TagsInput;
